import { register } from "register-service-worker";
import { capture, captureException } from "@/posthog";
import { setWaitingWorker } from "@/utils/pwaUpdate";
import { setSnackbar } from "@/stores/ui";

function promptPwaUpdate(registration) {
  if (!registration?.waiting) return;

  setWaitingWorker(registration.waiting);
  setSnackbar({
    text: "Une nouvelle version est disponible.",
    color: "info",
    timeout: -1,
    actionText: "Actualiser",
    action: "pwa-reload",
  });
}

if (process.env.NODE_ENV === "production")
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
        "For more details, visit https://goo.gl/AFskqB",
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      promptPwaUpdate(registration);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; waiting for user confirmation.");
      promptPwaUpdate(registration);
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
      capture("app_offline");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
      captureException(error, {
        flow: "service_worker",
      });
    },
  });
